import React, {useEffect, useState} from 'react';
import {useLocation} from 'react-router-dom';
import {Container, CircularProgress} from '@mui/material';
import {confirmEmailPath} from '../services/api';
import ConfirmEmailMessage from '../components/ConfirmEmailMessage';
import {Box} from '@mui/material';

const ConfirmEmail: React.FC = () => {
    const [isConfirmed, setIsConfirmed] = useState<boolean | null>(null);
    const [error, setError] = useState<string | null>(null);
    const location = useLocation();

    useEffect(() => {
        const confirm = async () => {
            const params = new URLSearchParams(location.search);
            const token = params.get('token');

            if (!token) {
                setError('No confirmation token provided');
                return;
            }

            try {
                await confirmEmailPath(token);
                setIsConfirmed(true);
            } catch (error) {
                setError('Ошибка подтверждения email. Пожалуйста, свяжитесь с поддержкой.');
                setIsConfirmed(false);
            }
        };

        confirm();
    }, [location]);

    if (isConfirmed === null && !error) {
        return (
            <Container component="main" maxWidth="xs">
                <Box sx={{marginTop: 8, display: 'flex', justifyContent: 'center'}}>
                    <CircularProgress  style={{color: '#3a485b'}}/>
                </Box>
            </Container>
        );
    }

    return (
        <Container component="main" maxWidth="xs">
            <ConfirmEmailMessage isConfirmed={isConfirmed} error={error}/>
        </Container>
    );
};

export default ConfirmEmail;